// Side-effect import: registers @mui module augmentations so external
// consumers of @rmh/ds (e.g. rmh-patient) can typecheck the component
// override sources that reference the augmented variants/sizes.
import "./augmentations.ts";

export { createRmhTheme, rmhTheme } from "./createRmhTheme";
export { lightPalette, darkPalette } from "./palette";
export { typography } from "./typography";
export { components } from "./components";
